(function(angular){
	'use strict';

	angular
		.module('cancelRedemptionRequestModalModule')
		.controller('CancelRedemptionRequestModalController', [
			'close',
			'ignoreClose',
			'redemptionRequestId',
			'type',
			'TransactionsFactory',
			'urlFactory',
			CancelRedemptionRequestModalFunction
		]);

	function CancelRedemptionRequestModalFunction(
		close,
		ignoreClose,
		redemptionRequestId,
		type,
		TransactionsFactory,
		urlFactory
	) {
		var cancelRedemptionRequestModal = this;

		cancelRedemptionRequestModal.redemptionRequestId = redemptionRequestId;
		cancelRedemptionRequestModal.type = type;

		cancelRedemptionRequestModal.close = close;
		cancelRedemptionRequestModal.ignoreClose = ignoreClose;

		cancelRedemptionRequestModal.cancelRedemptionRequestTransaction = function () {
			TransactionsFactory.cancelRedemptionRequestTransaction(redemptionRequestId, type)
				.then(function (successUrl) {
					urlFactory.redirect(successUrl);
				})
				.catch(function () {
					cancelRedemptionRequestModal.formSubmitted = false;
					cancelRedemptionRequestModal.close();
				});
		};
	}

})(window.angular);
